<template>
  <div :class="topClass">
    Pertambangan
    <div :class="className">
      <div class="flex-row items-center">
        <input
          type="radio"
          value="1"
          v-model="chooseMine"
          style="margin-right: 10px"
        />
        <div>Inti</div>
      </div>
      <div class="flex-row items-center">
        <input
          type="radio"
          value="0"
          v-model="chooseMine"
          style="margin-right: 10px"
        />
        <div>Non Inti</div>
      </div>
      <div class="btn-filter-clear" @click="clearChoosed">
        <i class="fa-solid fa-xmark"></i>
        Clear
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['className', 'topClass'],
  computed: {
    chooseMine: {
      get: function() {
        return this.$store.state.searchStore.chooseMine
      },
      set: function(newValue) {
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'chooseMine',
          value: newValue,
        })

        if (newValue == 0) {
          this.$store.commit('searchStore/SET_SEARCH_VALUE', {
            name: 'choosedIujp',
            value: [],
          })
        }
      },
    },
  },
  methods: {
    clearChoosed() {
      this.$store.commit('searchStore/SET_SEARCH_VALUE', {
        name: 'chooseMine',
        value: null,
      })
    },
  },
}
</script>
